import {
	type Client,
	type UserAttributes,
	createInstance,
	setLogger,
} from '@optimizely/optimizely-sdk/dist/optimizely.lite.es'
import type { BackofficeMasterData } from 'types/backoffice/masterData'
import type { Datafile, UserContext } from 'types/featureFlag'
import type { MasterData } from 'types/masterData'
import { flattenObject } from 'utils/flattenObject'

import { LIBRARY_NOT_INITIALIZED, USER_NOT_DEFINED } from './constants/logs'
import type { FeatureFlag, FeatureFlagServerProps } from './types'

const clientId = 'genesis'

setLogger(null)

let datafile: Datafile

export const setFeatureFlagDatafile = (newDatafile: Datafile): void => {
	datafile = newDatafile
}

let featureFlagService: Client | null
let user: UserContext

export const featureFlagServer = ({
	featureFlagId,
	masterData,
}: FeatureFlagServerProps): FeatureFlag => {
	if (!featureFlagService) {
		featureFlagService = createInstance({
			datafile,
		})
	}

	if (!user) {
		user = createUser(masterData)
	} else {
		setAttributes({
			...JSON.parse(JSON.stringify(flattenObject({ ...masterData, clientId }))),
		})
	}

	if (user) {
		const decision = user.decide(featureFlagId)

		return {
			variables: decision.variables,
			enabled: decision.enabled,
		}
	}

	console.error(USER_NOT_DEFINED)

	return {
		variables: undefined,
		enabled: false,
	}
}

export const createUser = (
	attributes: Partial<MasterData> | Partial<BackofficeMasterData>
): UserContext => {
	if (featureFlagService) {
		user = featureFlagService.createUserContext(clientId, {
			...JSON.parse(JSON.stringify(flattenObject({ ...attributes, clientId }))),
		})

		return user
	}

	console.error(LIBRARY_NOT_INITIALIZED)
	return null
}

export const getAttributes = (): UserAttributes | null => {
	if (user) {
		return user.getAttributes()
	}
	console.error(USER_NOT_DEFINED)
	return null
}

export const setAttributes = (attributes: UserAttributes = {}): void | null => {
	if (!user) {
		console.error(USER_NOT_DEFINED)
		return null
	}

	Object.keys(attributes).forEach((key) => {
		user?.setAttribute(key, attributes[key])
	})
}

export const setAttribute = (
	key: string,
	value: string
): UserContext | null => {
	if (user) {
		user.setAttribute(key, value)
		return user
	}
	console.error(USER_NOT_DEFINED)
	return null
}
